/** @type {Object.<string, import('../../..').LocationAnalysisType>} */
const LocationAnalysisType = {
    RADIUS: {
        ID: 'RADIUS',
        NAME: 'Radius',
        VALUES_ARRAY: [1, 3, 5, 10, 20],
        UNIT: 'mile',
        // TODO: I'm not sure where properties UNIT_LONG and UNIT_LONG_PLURAL
        // are used inside the application
        UNIT_LONG: 'mile',
        UNIT_LONG_PLURAL: 'miles',
        UNIT_DESC: 'radius',
        UNIT_DESC_PLURAL: 'radiuses',
        IMG: 'radius',
        ICON: 'album',
        MAPBOX_ROUTING_PROFILE: undefined,
        MAX_CUSTOM_VALUE: 20,
        VISUAL_REPORT_PROFILE: 'radius',
        ISGEOGRAPHY: false,
        CONTOUR_TYPE: 'radius',
        DEFAULT_VALUES: [1, 3, 5],
    },
    DRIVING_TIME: {
        ID: 'DRIVING_TIME',
        NAME: 'Drive time',
        VALUES_ARRAY: [5, 10, 15, 20, 30, 45, 60],
        UNIT: 'min',
        UNIT_LONG: 'minute',
        UNIT_LONG_PLURAL: 'minutes',
        UNIT_DESC: 'duration',
        UNIT_DESC_PLURAL: 'durations',
        IMG: 'drive-time',
        ICON: 'drive_eta',
        MAPBOX_ROUTING_PROFILE: 'mapbox/driving',
        NOTE: 'We are using average traffic data for drive time. ',
        // maximum value is set to 60 minutes because of limitation in mapbox API
        // ref: https://docs.mapbox.com/api/navigation/isochrone/#isochrone-api-restrictions-and-limits
        MAX_CUSTOM_VALUE: 60,
        VISUAL_REPORT_PROFILE: 'driving',
        ISGEOGRAPHY: false,
        CONTOUR_TYPE: 'driving',
        DEFAULT_VALUES: [5, 10, 15],
    },
    // A shape the user draws on the map. One "ring" (selection `[0]`); the
    // ring's vertices ride on the item (`LocationAnalysisItem#ring`), and the
    // backend reads them from the `polygon` param. Native insight panel only.
    POLYGON: {
        ID: 'POLYGON',
        NAME: 'Custom shape',
        VALUES_ARRAY: [0],
        UNIT: '',
        UNIT_LONG: '',
        UNIT_LONG_PLURAL: '',
        UNIT_DESC: 'shape',
        UNIT_DESC_PLURAL: 'shapes',
        IMG: '',
        ICON: 'polyline',
        MAPBOX_ROUTING_PROFILE: undefined,
        NOTE: undefined,
        MAX_CUSTOM_VALUE: 0,
        VISUAL_REPORT_PROFILE: 'polygon',
        ISGEOGRAPHY: false,
        CONTOUR_TYPE: 'polygon',
        DEFAULT_VALUES: [0],
    },
    GEO: {
        ID: 'GEO',
        NAME: 'Geography',
        VALUES_ARRAY: [],
        UNIT: '',
        UNIT_LONG: '',
        UNIT_LONG_PLURAL: '',
        UNIT_DESC: '',
        UNIT_DESC_PLURAL: '',
        IMG: '',
        ICON: '',
        MAPBOX_ROUTING_PROFILE: undefined,
        NOTE: undefined,
        MAX_CUSTOM_VALUE: 20,
        VISUAL_REPORT_PROFILE: '',
        ISGEOGRAPHY: true,
        CONTOUR_TYPE: 'custom_geo',
        DEFAULT_VALUES: [],
    },
};

export default LocationAnalysisType;
